import { render, staticRenderFns } from "./GithubPaired.vue?vue&type=template&id=65b2268b&scoped=true&"
import script from "./GithubPaired.vue?vue&type=script&lang=js&"
export * from "./GithubPaired.vue?vue&type=script&lang=js&"
import style0 from "./GithubPaired.vue?vue&type=style&index=0&id=65b2268b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2268b",
  null
  
)

export default component.exports